module.exports = __webpack_public_path__ + "static/media/pulse.4e6d02e7.gif";